<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
};
</script>

<style>
#app {
    /*text-align: center;*/
    color: #2c3e50;
    /*margin-top: 60px;*/
    height: 100%;
    width: 100%;
    font-size: 15px;
}
@font-face {
  font-family: 'iconfont';  /* Project id 2314829 */
  src: url('//at.alicdn.com/t/font_2314829_pa45o7hase.woff2?t=1620785161414') format('woff2'),
       url('//at.alicdn.com/t/font_2314829_pa45o7hase.woff?t=1620785161414') format('woff'),
       url('//at.alicdn.com/t/font_2314829_pa45o7hase.ttf?t=1620785161414') format('truetype');
}
.iconfont {
    font-family: "iconfont" !important;
    font-size: 22px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

html,
body {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    border: 0;
}
/* td .cell{
    white-space: pre !important;
} */
.ordermenu .el-tabs__item.is-active {
    color: #333940;
    font-size: 18px !important;
}
.ordermenu .el-tabs__item {
    color: #333940;
    font-size: 18px !important;
}
.el-dialog__title {
    font-size: 18px !important;
}
.el-page-header__title {
    font-size: 18px !important;
}
.el-page-header__content {
    font-size: 18px !important;
}
.el-dialog__header {
     font-size: 18px !important;
}
.el-dialog{
    margin-top:8vh !important;
}
.el-form-item__label {
    font-size: 16px !important;
    color: #292E33 !important;
    line-height: 42px !important;
}
.el-pagination {
    font-size: 14px !important;
}
.el-pager li{
    font-size: 14px !important;
}
.el-pagination__sizes .el-input .el-input__inner{
    font-size: 14px !important;
}
.el-pagination button, .el-pagination span:not([class*=suffix]){
    font-size: 14px !important;
}
.el-input--mini .el-input__inner{
    font-size: 14px;
}
.el-table th>.cell{
    font-size: 14px;
    color: #606266;
    font-weight: 500;
}
.el-table th.must > .cell:before {
    content: "*";
    color: #ff1818;
}
.el-table td,
.el-table th {
    padding: 5px 0 !important;
}
.app-container {
    padding: 20px 30px;
    background: #ffffff;
}
.el-table{
    width: 99.9% !important;
}
.el-table th {
    background: #f3f3f3;
}
.el-textarea__inner{
    min-height: 60px !important;
}
.el-image-viewer__close{
    color: #fff;
    background-color: #606266;
}
.ordermenu .el-tabs__item:after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 10px;
    width: 1px;
    height: 13px;
    background-color: #CCCCCC;
    z-index: 1;
}

.ordermenu .el-tabs__item:last-child:after {
    display: none;
}

.ordermenu .el-tabs__nav-wrap::after {
    height: 0 !important;
}

.ordermenu .el-tabs__nav-wrap {
    padding: 10px 15px;
    border-bottom: 1px solid rgba(115, 121, 128, 0.11);
}

.ordermenu .el-tabs__content {
    margin: 15px;
}
.introduction .el-tabs__header {
    padding: 0 20px !important;
    background: #F3F3F3;
}

.introduction .el-tabs__nav-wrap::after {
    background-color: #F3F3F3 !important;
}

.introduction .el-tabs__nav {
    padding: 0 30px !important;
}

.introduction .el-tabs__nav.is-top {
    background: #ffffff;
}

.introduction .el-tabs__item.is-active {
    font-size: 16px !important;
    font-weight: 500 !important;
    color: #333940 !important;
}

.introduction .el-tabs__active-bar {
    padding: 0 30px !important;
    background: #1E80E1 !important;
}
.el-radio{
    margin-right:10px !important;
}
.el-scrollbar .el-scrollbar__bar {
    opacity: 1 !important;
}
.el-message__icon{
    font-size: 14px !important;
}

.rootbtn{
	margin-top: 22px;
	display: flex;
	justify-content: center;
}
.top_title{
    line-height: 28px;
    font-size: 18px;
    color: #333940;
}
.searchtips{
    font-size: 16px;
    padding-right: 10px;
    color: #292e33;
    line-height: 40px;
}
.normaltips{
    font-size: 14px;
    padding-right: 10px;
    color: #292e33;
}
.errorFonts_mini{
    text-align: center;
    font-size: 14px;
    color: #c0c4cc;
    background: #f5f7fa;
}
.errorFonts{
    width: 100%;
    height: 100%;
    font-size: 14px;
    position: relative;
    color: #c0c4cc;
    background: #f5f7fa;
}
.errorFonts div{
    width: 100%;
    text-align: center;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
}
.searchItem {
    display: flex;
    position: relative;
    flex-wrap: wrap;
}
.searchItem .search {
    margin-right: 10px;
    margin-bottom: 22px;
    font-size: 16px;
}

input[type=number] {  
    -moz-appearance:textfield;  
}  
input[type=number]::-webkit-inner-spin-button,  
input[type=number]::-webkit-outer-spin-button {  
    -webkit-appearance: none;  
    margin: 0;  
}
.uni_ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.col_title{
	font-size: 16px;
	font-weight: bolder;
}
.red {
    color: red !important;
}
.date_select{
    position: absolute;
    right: 20px;
    top: 0px;
    padding:18px 0px;
    height: 28px;
    display: flex;
}
.total_title{
    line-height: 28px;
    font-size: 16px;
    color: #333;
    font-weight: 500;
}
.date_mode{
    padding:0 12px;
    border-radius: 13px;
    margin-right: 10px;
    line-height: 24px;
    font-size: 12px;
    border:1px solid #ccc;
    cursor: pointer;
}
.date_mode.select{
    background: #1890ff;
    border:none;
    color: #fff;
    line-height: 26px;
}
</style>
